/* eslint-disable max-len */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const replicateFrameworkMappingData = async (
  year: string = '',
  source: string,
  target: string
): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.ESG.replicateFramework.replicateFrameworkMappingData}/${companyID}/${year}/${source}/${target}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return response.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default replicateFrameworkMappingData;
